// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-head_container__oW1gO"};